export default __webpack_public_path__ + "static/media/womens_polutechnics_college.3c6eb4e2.webp";